export default __webpack_public_path__ + "images/height_saturation.f03021f.svg";